module.exports = __webpack_public_path__ + "static/kartchen-arbeiten-wohnen3-2ffca34b8dfe892ad4c39cf4338b12e4.png";